<template>
	<div class="fi-row">
		<span class="fi-rowIcon"><sym-icon :name="icon"></sym-icon></span>
		<div v-if="isStringWarn" class="fi-row-message">
			<span>{{ warn }}</span>
		</div>
		<div v-else class="fi-row-message">
			<span>{{ warn.message }}</span>
			<span v-if="warn.actions" v-html="warn.actions"></span>
		</div>
	</div>
</template>

<script setup lang="ts">
import {computed} from "vue";
import SymIcon from "@fd/helpers/SymIcon.vue";
import {Warning} from "@t/note/Comment.ts";

const props = defineProps<{
	warn: Warning | string
}>();

const icon = computed<string>(()=> props.warn.icon || "warning-18-bold");
const isStringWarn = computed<boolean>(() => typeof props.warn === "string");
</script>

<style>

</style>